import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/order`;

export const ROUTE: RouteDefinition = `${baseRoute}/order`;

export const URL = (): RouteDefinition =>
	`${baseRoute}/order`;
